import { render, staticRenderFns } from "./login-panel.vue?vue&type=template&id=63a2f2a1&scoped=true&"
import script from "./login-panel.vue?vue&type=script&lang=js&"
export * from "./login-panel.vue?vue&type=script&lang=js&"
import style0 from "./login-panel.vue?vue&type=style&index=0&id=63a2f2a1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a2f2a1",
  null
  
)

export default component.exports